import { DetailedHTMLProps, HTMLAttributes } from 'react';

export type OmitUnitType<T, I> = T extends I ? never : T;
export type ReactComponentProps<T> = DetailedHTMLProps<HTMLAttributes<T>, T>;
export type BitBoolean = 0 | 1;
export type ResponseMeta = {
  pagination: {
    limit: number;
    offset: number;
    total: number;
  };
};

export type Response<ResponseData> = {
  data: ResponseData;
  meta?: ResponseMeta;
};

export interface IConfigurationKey<T> {
  name: T;
  shouldRenderWhenItIs: boolean;
}

export enum ErrorCodes {
  ServerError = 'ServerError',
  InvalidRequestError = 'InvalidRequestError',
  InvalidOperation = 'InvalidOperation',
  NameAlreadyExists = 'NameAlreadyExists',
  EmailAlreadyExists = 'EmailAlreadyExists',
  SiteNotActive = 'SiteNotActive',
  SiteNotFound = 'SiteNotFound',
  UserNotFound = 'UserNotFound',
  RoleNotFound = 'RoleNotFound',
  ContactNotFound = 'ContactNotFound',
  SiteCreationError = 'SiteCreationError',
  UserCreationError = 'UserCreationError',
  RoleCreationError = 'RoleCreationError',
  ForbiddenOperationForSiteGuid = 'ForbiddenOperationForSiteGuid',
  ForbiddenOperationForUser = 'ForbiddenOperationForUser',
  ParentSiteMustBeSitesContainer = 'ParentSiteMustBeSitesContainer',
  SiteMustBeSitesContainer = 'SiteMustBeSitesContainer',
  SiteMustHaveAtleastOneContact = 'SiteMustHaveAtleastOneContact',
  AllSitesUnderMustBeDeleted = 'AllSitesUnderMustBeDeleted',
  AllSitesUnderMustBeHardDeleted = 'AllSitesUnderMustBeHardDeleted',
  RoleHasAssociatedUsers = 'RoleHasAssociatedUsers',
  FeatureNotSupported = 'FeatureNotSupported',
  ResetPasswordTokenExpired = 'ResetPasswordTokenExpired',
  RegistrationTokenExpired = 'RegistrationTokenExpired'
}
